module.exports = __webpack_public_path__ + "img/barrier-and-car.ce87c2d9.svg";